import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.css']
})

/**
 * Changelog Component
 */
export class ChangelogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
